export enum ServiceTypeStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export interface ServiceTypeAuditActor {
  id: string;
  name: string;
  user_id: string;
}

export interface ServiceType {
  id: string;
  service_name: string;
  description: string;
  status: ServiceTypeStatus;
  created_at: string;
  updated_at: string;
  created_by: ServiceTypeAuditActor | null;
  updated_by: ServiceTypeAuditActor | null;
}

export interface CreateServiceTypePayload {
  service_name: string;
  description: string;
}

export interface ServiceTypeListItem {
  id: string;
  service_name: string;
  description: string;
  status: ServiceTypeStatus;
  created_at: string;
}

export interface ListServiceTypesResponse {
  data: ServiceTypeListItem[];
  totalCount: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface ListServiceTypesParams {
  search?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}
